import styled from 'styled-components';
import { BodyCopyMedium } from './styles/globalStyles';

export const LimitContainer = styled.div.attrs<{}>({
	className: 'tws-limit-container',
})`
	display: flex;
	justify-content: end;
	align-items: center;
`;
LimitContainer.displayName = 'LimitContainer';

export const BodyCopyMediumContainer = styled(BodyCopyMedium).attrs<{}>({})`
	margin-right: 10px;
	margin-top: revert;
`;
BodyCopyMediumContainer.displayName = 'BodyCopyMediumContainer';
